import React ,{ useState, useEffect } from "react";
import styles from  "./index.module.css";
function WeatherTip() {
  const [UV_index, setUV_index] = useState("");
  const [air_index, setPM2_5] = useState("");
  const uv_url = "https://devapi.qweather.com/v7/indices/1d?key=c53e817f8e7a4b40ac69fa4d3befc76d&type=5&location=101210101"
  const air_url = "https://devapi.qweather.com/v7/air/now?key=c53e817f8e7a4b40ac69fa4d3befc76d&type=0&location=101210101"
  useEffect(() => {
      fetch(uv_url)
      .then(res => res.json())
      .then(data => {
        if(data?.daily?.length){
          setUV_index(data.daily[0].category);
        }
          
      })
      fetch(air_url)
      .then(res => res.json())
      .then(data => {
        if(data?.now?.category){
          setPM2_5(data.now.category);
        }
      })
  })
  return (
    <div className={styles['weather-tip']} >
      <div className={styles['weather-item']} >
        <div className={styles['weather-des']} >
          紫外线指数：
        </div>
        <div className={styles['weather-value']} >
          {UV_index}
        </div>
      </div>
      <div className={styles['weather-item']} >
        <div className={styles['weather-des']} >
        空气质量指数：
        </div>
        <div className={styles['weather-value']} >
          {air_index}
        </div>
      </div>
     
    </div>
  );
}

export default WeatherTip;
